const config = {
  API_ROOT: `https://backend-pro-tools.bis-apps.com/api/`, // test🐼
};

export default config;
